import { Alert, Badge, Button, Card, CardBody, CardHeader, Spinner, Table } from "reactstrap";
import { Box, RefreshCw } from "react-feather";
import { useGetMyAssetsQuery } from "../../../../ReduxToolkit/api/employeeAssets";
import { useEmployeeProfile } from "../../../../hooks/useEmployeeProfile";

const EmployeeAssetsTab = () => {
  const { id, loggedInEmployee, loggedInEmployeeRole } = useEmployeeProfile();
  const isOwnProfile = Number(id) === Number(loggedInEmployee?.id);
  const canViewAssets = isOwnProfile || ["admin", "hr"].includes(loggedInEmployeeRole);
  const { data, isLoading, isFetching, isError, refetch } = useGetMyAssetsQuery(isOwnProfile ? undefined : { userId: Number(id) }, { skip: !canViewAssets || !id });
  if (!canViewAssets) return null;
  const assets = data?.data ?? [];
  return (
    <Card>
      <CardHeader className="b-l-primary border-3 py-2 px-3 d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <h5 className="mb-0 f-w-400 f-14">{isOwnProfile ? "My Assets" : "Employee Assets"}</h5>
          {data?.status && <Badge color="primary" className="text-white">{assets.length} assets</Badge>}
        </div>
        <Button color="light" size="sm" className="px-2 py-1" disabled={isFetching} onClick={() => refetch()} aria-label="Refresh assets"><RefreshCw size={15} aria-hidden="true" /></Button>
      </CardHeader>
      <CardBody className="px-3 pt-1 pb-3">
        {isLoading ? <div className="text-center py-4" role="status"><Spinner size="sm" color="primary" /> <span>Loading assets…</span></div>
          : isError || data?.status === false ? <Alert color="danger">{data?.message ?? "Unable to load assets. Please try again."} <Button color="link" size="sm" onClick={() => refetch()}>Retry</Button></Alert>
          : !assets.length ? <div className="text-center text-muted py-4"><Box size={30} aria-hidden="true" /><div className="mt-2">{isOwnProfile ? "No assets assigned to you." : "No assets assigned to this employee."}</div></div>
          : <div className="table-responsive custom-scrollbar">
            <Table className="mb-0 align-middle f-12" hover>
              <thead><tr>{["Product Code", "Category", "Brand", "Model", "Serial Number", "Configuration", "Status", "Condition"].map((label) => <th scope="col" className="text-nowrap" key={label}>{label}</th>)}</tr></thead>
              <tbody>{assets.map((asset) => (
                <tr key={asset.id}>
                  <td className="text-nowrap">{asset.product_code || "-"}</td>
                  <td>{asset.category?.name || "-"}</td>
                  <td>{asset.brand || "-"}</td>
                  <td>{asset.model || "-"}</td>
                  <td>{asset.serial_number || "-"}</td>
                  <td>{asset.configuration || "-"}</td>
                  <td><Badge color={asset.status === "Assigned" ? "success" : "primary"} className="text-white text-nowrap">{asset.status || "-"}</Badge></td>
                  <td>{asset.condition || "-"}</td>
                </tr>
              ))}</tbody>
            </Table>
          </div>}
      </CardBody>
    </Card>
  );
};
export default EmployeeAssetsTab;
